// Profile component with error handling and logging

import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { firestore, storage } from '../../../firebase'; 
import './Profile.css'; 

// const styles = {
//   text: { 
//     color: '#000',
//     fontFamily: "Notable, sans-serif",
//     fontWeight: "400",
//     fontStyle: "normal",
//   },
// };

const Profile = ({ uid }) => {
  const [userData, setUserData] = useState(null);
  const [profileImageUrl, setProfileImageUrl] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userDoc = await firestore.collection('users').doc(uid).get();
        if (userDoc.exists) {
          setUserData(userDoc.data());

          // Fetch profile image URL from Firebase Storage
          const imageRef = storage.ref(`profileImages/${uid}/${uid}.jpg`); 
          const url = await imageRef.getDownloadURL();
          setProfileImageUrl(url);
        } else {
          setError('User document not found');
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
        setError(error.message);
      }
    };

    fetchUserData();
  }, [uid]);

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!userData) {
    return <div>Loading user data...</div>;
  }

  return (
    <div className="profile-section">
      <h2><FontAwesomeIcon icon={faUser} /> Student  Information </h2>
      <div className="profile-content">
        {profileImageUrl && <img src={profileImageUrl} alt="Profile" className="profile-image" />}
        <div>
          <h2>Name: {userData.name}</h2>
          <p>Email: {userData.email}</p>
        </div>
      </div>
    </div>
  );
};

export default Profile;
